var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD16TextBlock = function SvgD16TextBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-16-text-block_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-16-text-block_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.421 3H3.604a.584.584 0 0 0-.585.573v1.26a.573.573 0 0 0 1.145 0v-.688h2.634v8.32h-.675a.573.573 0 0 0 0 1.146h3.779a.573.573 0 0 0 0-1.145h-.7V4.145h2.634v.687a.573.573 0 0 0 1.145 0v-1.26A.562.562 0 0 0 12.42 3z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgD16TextBlock;